<template>
  <CertifiedPartnerSerialnosForm v-model="serialnos" @validation-change="onValidationChange" />
</template>
<script>
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import CertifiedPartnerSerialnosForm from '@/components/users/registrations/certified_partner_serialnos_form.vue'

export default {
  name: 'NewUserCertifiedPartnerSerialnos',
  components: {
    CertifiedPartnerSerialnosForm
  },
  setup() {
    const hiddenFormInputField = document.getElementById('serialnos-input-field')
    const form = hiddenFormInputField?.closest('form') || document.querySelector('form')

    const serialnos = ref(hiddenFormInputField?.value ? hiddenFormInputField.value.split(',') : [])
    const validationState = ref({
      hasSerialnos: serialnos.value.length > 0,
      isNewSerialnoValid: true,
      hasInteracted: false
    })
    const validationActive = ref(false)

    const setHiddenFormInputField = () => {
      if (!hiddenFormInputField) return
      hiddenFormInputField.value = serialnos.value.join(',')
    }

    const applyFieldValidity = ({ force = false } = {}) => {
      const input = document.getElementById('input-serialno')
      if (!input) return

      if (!force && !validationState.value.hasInteracted) {
        input.setCustomValidity('')
        return
      }

      if (!validationState.value.hasSerialnos) input.setCustomValidity('Please add at least one serial number.')
      else if (!validationState.value.isNewSerialnoValid) input.setCustomValidity('Invalid serial number format.')
      else input.setCustomValidity('')
    }

    watch(serialnos, () => {
      setHiddenFormInputField()
      applyFieldValidity({ force: validationActive.value })
    })

    const applyWasValidatedClass = () => {
      if (form && !form.classList.contains('was-validated')) form.classList.add('was-validated')
    }

    const onFormSubmit = () => {
      validationActive.value = true
      applyWasValidatedClass()
      applyFieldValidity({ force: true })
    }

    onMounted(() => {
      if (form) form.addEventListener('submit', onFormSubmit)
    })

    onBeforeUnmount(() => {
      if (form) form.removeEventListener('submit', onFormSubmit)
    })

    return {
      onValidationChange: (state) => {
        validationState.value = state

        if (state.hasInteracted) {
          validationActive.value = true
          applyWasValidatedClass()
        }

        applyFieldValidity({ force: validationActive.value })
      },
      serialnos
    }
  }
}
</script>
